__turbopack_context__.v({
  "aiModalContainer": "styles-module-scss-module__xdCS2q__aiModalContainer",
  "icon": "styles-module-scss-module__xdCS2q__icon",
  "questionButton": "styles-module-scss-module__xdCS2q__questionButton",
  "suggestion": "styles-module-scss-module__xdCS2q__suggestion",
});
